<template>
  <div class="value-blocks-slider-component horizontal-scroll-component" id="valueBlocksSliderComponent" role="region" :data-brand="brand.substr(0,1).toLowerCase() + brand.substr(1)">
    <div class="value-blocks-slider scroll-parent" data-has-scrollbar="true" data-view-is-preview="false" id="valueBlocksSlider" data-scroll-region="min">
      <div class="scroll-horizontal">
        <div class="slider-card has-transition" :style="{backgroundImage: suvBox}">
          <div class="slider-card-content">
            <div class="slider-card-top">
              <p class="slider-card-tagline">All New {{ brandName }} {{ newModel }}</p>
            </div>
            <div class="slider-card-bottom">
              <p class="slider-card-title">Explore Today</p>
              <a class="slider-card-btn has-transition" href="#">Shop {{ newModel }}</a>
            </div>
          </div>
        </div>
        <div class="slider-card has-transition" :style="{backgroundImage: sedanBox}">
          <div class="slider-card-content">
            <div class="slider-card-top">
              <p class="slider-card-tagline">All the rave</p>
            </div>
            <div class="slider-card-bottom">
              <p class="slider-card-title">Shop the most popular models</p>
              <a class="slider-card-btn has-transition" href="#">Shop Models</a>
            </div>
          </div>
        </div>
        <div class="slider-card has-transition" id="service-background">
          <div class="slider-card-content">
            <div class="slider-card-top">
              <p class="slider-card-tagline">Service Special</p>
            </div>
            <div class="slider-card-bottom">
              <p class="slider-card-title">$59.95 Synthetic Oil Change</p>
              <a class="slider-card-btn has-transition" href="#">Claim Offer</a>
            </div>
          </div>
        </div>
        <div class="slider-card has-transition" :style="{backgroundImage: truckBox}">
          <div class="slider-card-content">
            <div class="slider-card-top"></div>
            <div class="slider-card-bottom">
              <p class="slider-card-title">Stop by today for a limited time offer!</p>
              <a class="slider-card-btn has-transition" href="#">Shop Online</a>
            </div>
          </div>
        </div>
        <div class="slider-card has-transition" id="parts-background">
          <div class="slider-card-content">
            <div class="slider-card-top"></div>
            <div class="slider-card-bottom">
              <a class="slider-card-btn has-transition" href="#">Shop Parts</a>
            </div>
          </div>
        </div>
      </div>
      <div class="scroll-nav scroll-nav--left">
        <button class="scroll-nav-btn" data-direction="left" data-scroll-parent="#valueBlocksSlider" tabindex="0" type="button"></button>
      </div>
      <div class="scroll-nav scroll-nav--right">
        <button class="scroll-nav-btn" data-direction="right" data-scroll-parent="#valueBlocksSlider" tabindex="0" type="button"></button>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['images'],
  data() {
    return {
      brand: this.$store.state.chosenBrand,
    }
  },
  computed: {
    brandName () {
      if (this.brand === 'none') {
        return 'Brand';
      } else if (this.brand === 'infiniti' || this.brand === 'cjdr') {
        return this.brand.toUpperCase();
      } else {
        return this.brand.charAt(0).toUpperCase() + this.brand.slice(1);
      }
    },
    sedanBox () {
      if (this.brand === 'kia' || this.brand === 'lincoln' || this.brand === 'mitsubishi' || this.brand === 'nissan' || this.brand === 'toyota') {
        return 'url(' + this.images.lifestyleImages.defaultImage + ')';
      } else {
        return 'url(' + this.images.lifestyleImages.sedanImage + ')';
      }
    },
    suvBox () {
      if (this.brand === 'kia') {
        return 'url(' + this.images.lifestyleImages.truckImage + ')';
      } else {
        return 'url(' + this.images.lifestyleImages.suvImage + ')';
      }
    },
    truckBox () {
      if (this.brand === 'kia') {
        return 'url(' + this.images.lifestyleImages.suvImage + ')';
      } else {
        return 'url(' + this.images.lifestyleImages.truckImage + ')';
      }
    },
    newModel () {
      if (this.brand === 'kia') {
        return 'Telluride';
      } else {
        return this.images.suvs[0].modelName;
      }
    }
  },
  mounted() {
    (function($){
  const scrollingSpeedRatio = 0.7;
  const tabPaneTriggerDelayMilliseconds = 220;
  const horizontalScroll = {
    init: function() {
      if ($('.horizontal-scroll-component').length === 0) {
        return false;
      }
      
      horizontalScroll.scrollNavInit();

      $('.horizontal-scroll-component .scroll-parent').each(function(){  
        let parent = '#' + $(this).attr('id');
        let element = parent + ' .scroll-horizontal';
        horizontalScroll.setDataRegion(parent, element);
        horizontalScroll.setDataHasScrollbar(parent, element);
        $(window).resize(function(){
          horizontalScroll.setDataHasScrollbar(parent, element);
        });
        $(element).on('scroll', function(){
          horizontalScroll.setDataRegion(parent, element);
        });
      });

      $('.horizontal-scroll-component [data-toggle="tab"]').click(function(){
        setTimeout(function(){
          $('.horizontal-scroll-component .tab-content .scroll-parent').each(function(){
            let parent = '#' + $(this).attr('id');
            let element = parent + ' .scroll-horizontal';
            horizontalScroll.setDataHasScrollbar(parent, element);
          });
        }, tabPaneTriggerDelayMilliseconds);
      });

    }, 

    scrollNavInit: function() {
      $('.horizontal-scroll-component .scroll-parent .scroll-nav').click(function(){
        $(this).find('.scroll-nav-btn').focus();
        let scrollParent = $(this).find('.scroll-nav-btn').attr('data-scroll-parent');
        let scrollTarget = scrollParent + ' .scroll-horizontal';
        let scrollContent = scrollTarget + ' > *';
        let distance = 0;

        $(scrollContent).each(function(){
          if ($(this).outerWidth() > distance) {
            distance = $(this).outerWidth();
          }
        });
        
        let currentPosition = horizontalScroll.getPosition(scrollTarget);

        if ($(this).find('.scroll-nav-btn').attr('data-direction') === 'right') {
          horizontalScroll.animateScroll(scrollParent, scrollTarget, distance, currentPosition + distance);
        } else {
          horizontalScroll.animateScroll(scrollParent, scrollTarget, distance, currentPosition - distance);
        }
        
      })
    },

    setDuration: function(distance) {
      return Math.floor(distance / scrollingSpeedRatio);
    }, 

    animateScroll: function(parent, element, distance, newPosition) {
      $(element).animate({
          scrollLeft: newPosition
      }, horizontalScroll.setDuration(distance));
      setTimeout(function(){
        horizontalScroll.setDataRegion(parent, element);
      }, horizontalScroll.setDuration(distance));
    }, 

    getPosition: function(element) {
      return $(element).scrollLeft();
    }, 

    getMaxScroll: function(element) {
      return document.querySelector(element).scrollWidth - (document.querySelector(element).clientWidth + 10);
    }, 

    setDataRegion: function(parent, element) {
      let maxScroll = horizontalScroll.getMaxScroll(element);
      let currentPosition = horizontalScroll.getPosition(element);
      if (currentPosition === 0 && maxScroll < 0) {
        $(parent).attr('data-scroll-region', 'min');
      } else if (currentPosition >= maxScroll) {
        $(parent).attr('data-scroll-region', 'max');
      } else if (currentPosition === 0) {
        $(parent).attr('data-scroll-region', 'min');
      } else {
        $(parent).attr('data-scroll-region', 'middle');
      }
    }, 

    setDataHasScrollbar: function(parent, element) {
      if (horizontalScroll.getPosition(element) === 0 && horizontalScroll.getMaxScroll(element) <= 0) {
        $(parent).attr('data-has-scrollbar', 'false');
      } else {
        $(parent).attr('data-has-scrollbar', 'true');
      }
    }
  }

  $(document).ready(horizontalScroll.init);

})(jQuery)

  }
};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
/* Component Classes */

.value-blocks-slider-component .scroll-parent {
    position: relative;
    width: 100%;
    margin: 0 auto;
  }
  .value-blocks-slider-component .scroll-horizontal {
    position: relative;
    background-color: #ffffff;
    overflow-x: scroll;
    width: 100%;
    margin: 0 auto;
    white-space: nowrap;
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
  .value-blocks-slider-component .scroll-horizontal::-webkit-scrollbar {
    display: none;
  }
  .value-blocks-slider-component .scroll-horizontal > * {
    display: inline-block;
    white-space: normal;
    vertical-align: text-top;
  }
  .value-blocks-slider-component .scroll-overlay, 
  .value-blocks-slider-component .scroll-nav {
    width: 15%;
    height: 100%;
    position: absolute;
    top: 0;
    -webkit-transition: all 0.1s ease;
    -moz-transition: all 0.1s ease;
    -o-transition: all 0.1s ease;
    transition: all 0.1s ease;
  }

  .value-blocks-slider-component .scroll-parent[data-scroll-region="min"] .scroll-overlay--left,
  .value-blocks-slider-component .scroll-parent[data-scroll-region="max"] .scroll-overlay--right,
  .value-blocks-slider-component .scroll-parent[data-scroll-region="min"] .scroll-nav--left,
  .value-blocks-slider-component .scroll-parent[data-scroll-region="max"] .scroll-nav--right,
  .value-blocks-slider-component .scroll-parent[data-has-scrollbar="false"] .scroll-overlay,
  .value-blocks-slider-component .scroll-parent[data-has-scrollbar="false"] .scroll-nav {
    opacity: 0;
    visibility: hidden;
  }
  .value-blocks-slider-component .scroll-nav-btn {
    font-size: inherit;
    font-weight: 300;
    width: 30px;
    height: 30px;
    color: #ffffff;
    background-color: transparent;
    border: solid 2px #000000;
    border-radius: 100%;
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transition: all 0.3s ease;
    background-image: url("../../static/images/common-icons/right-arrow-black.png");
    background-size: 35%;
    background-position: center;
    background-repeat: no-repeat;
  }
  .value-blocks-slider-component .scroll-nav--left .scroll-nav-btn {
    transform: rotateY(180deg);
  }
  .value-blocks-slider-component .scroll-nav-btn:hover {
    opacity: 0.7;
  }

/* Component Custom Properties */
.value-blocks-slider-component {
  --pc: var(--primary-color, #333333);
  --pcd: var(--primary-dark, #000000);
  --card-width: 30vw;
}
#service-background {
  background-image: url(../../static/images/kia-service-stock-img.jpeg);
  background-position-x: 94%;
}
#parts-background {
  background-image: url(../../static/images/parts-service-stock-image.jpeg);
}

/* Utility Overrides */
.value-blocks-slider-component .value-blocks-slider .scroll-horizontal {
  position: relative;
  padding: 75px 30px;
}
.value-blocks-slider-component .scroll-overlay, 
.value-blocks-slider-component .scroll-nav {
  position: absolute;
  top: unset;
  bottom: 17.5px;
}
.value-blocks-slider-component .scroll-nav {
  height: fit-content;
  width: fit-content;
}
.value-blocks-slider-component .scroll-nav--left {
  left: unset;
  right: 80px;
  padding: 0;
}
.value-blocks-slider-component .scroll-nav--right {
  right: 20px;
  padding: 0;
}
.value-blocks-slider-component .scroll-nav-btn {
  filter: invert(1);
  width: 50px;
  height: 50px;
  border: none;
}
.value-blocks-slider-component.horizontal-scroll-component .scroll-nav-btn:focus, 
.value-blocks-slider-component.horizontal-scroll-component .scroll-nav-btn:active {
  -ms-transform: none;
  -webkit-transform: none;
  transform: none;
}
.value-blocks-slider-component.horizontal-scroll-component .scroll-nav--left .scroll-nav-btn:focus, 
.value-blocks-slider-component.horizontal-scroll-component .scroll-nav--left .scroll-nav-btn:active {
  -ms-transform: rotateY(180deg);
  -webkit-transform: rotateY(180deg);
  transform: rotateY(180deg);
}
.value-blocks-slider-component.horizontal-scroll-component .scroll-parent[data-scroll-region="min"] .scroll-nav--left, 
.value-blocks-slider-component.horizontal-scroll-component .scroll-parent[data-scroll-region="max"] .scroll-nav--right {
  visibility: visible;
  opacity: 0.3;
  pointer-events: none;
}
.value-blocks-slider-component .scroll-parent[data-has-scrollbar="false"] .scroll-nav {
  display: none;
}

/* Component Styles */
.value-blocks-slider-component .has-transition {
  -moz-transition: all 0.3s ease;
  -webkit-transition: all 0.3s ease;    
  transition: all 0.3s ease;
}
.value-blocks-slider-component .visibility-hidden {
  visibility: hidden;
}
.value-blocks-slider-component.horizontal-scroll-component .scroll-horizontal {
  background-color: #000000;
  background-color: var(--pcd);
}
.value-blocks-slider-component .slider-card {
  background-size: cover;
  background-position: center;
  width: var(--card-width, 30vw);
  height: calc(var(--card-width, 30vw) * 1.34);
  min-width: 346px;
  min-height: 464px;
  max-height: 600px;
  max-width: 450px;
  margin: 0 12px;
  color: #ffffff;
  background-color: #000000;
  background-color: var(--pcd);
}
.value-blocks-slider-component[data-brand='mitsubishi'] .slider-card {
  background-position-x: 75%;
}
.value-blocks-slider-component .slider-card.has-fallback-bg {
  background-blend-mode: luminosity;
}
.value-blocks-slider-component .slider-card-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  padding: 40px;
  background: linear-gradient(to top, #000000 2%, transparent 50%);
  background: linear-gradient(to top, var(--pcd) 2%, transparent 50%);
}
.value-blocks-slider-component .slider-card-top, 
.value-blocks-slider-component .slider-card-bottom {
  text-align: left;
}
.value-blocks-slider-component .slider-card-tagline {
  font-size: 20px;
  margin-bottom: 0;
}
.value-blocks-slider-component .slider-card-title {
  font-size: 28px;
  margin-bottom: 25px;
}
.value-blocks-slider-component .slider-card__disclaimer a {
  color: #ffffff;
  text-decoration: underline;
}
.value-blocks-slider-component .slider-card__disclaimer a:hover, 
.value-blocks-slider-component .slider-card__disclaimer a:active, 
.value-blocks-slider-component .slider-card__disclaimer a:focus {
  color: #ffffff;
}
.value-blocks-slider-component .slider-card-btn {
  display: inline-block;
  background-color: #ffffff;
  color: #000000;
  color: var(--pcd);
  font-size: 20px;
  padding: 12px 20px;
  border: solid 1px #ffffff;
}
.value-blocks-slider-component .slider-card-btn:hover, 
.value-blocks-slider-component .slider-card-btn:active, 
.value-blocks-slider-component .slider-card-btn:focus {
  outline: none;
  text-decoration: none;
  color: #ffffff;
  background-color: transparent;
}
.value-blocks-slider-component .slider-card-disclaimer {
  margin-top: 7px;
}
.value-blocks-slider-component .slider-card-disclaimer:hover, 
.value-blocks-slider-component .slider-card-disclaimer:focus {
  cursor: pointer;
  text-decoration: underline;
}

@media (max-width: 1512px) {
  .value-blocks-slider-component .slider-card-content {
    padding: 3vw;
  }
  .value-blocks-slider-component .slider-card-tagline {
    font-size: 1.3vw;
  }
  .value-blocks-slider-component .slider-card-title {
    font-size: 1.8vw;
  }
  .value-blocks-slider-component .slider-card-btn {
    font-size: 1.3vw;
  }
}

@media (max-width: 991px) {
  .value-blocks-slider-component .slider-card-tagline {
    font-size: 1.7vw;
  }
  .value-blocks-slider-component .slider-card-title {
    font-size: 2.4vw;
  }
  .value-blocks-slider-component .slider-card-btn {
    font-size: 1.7vw;
  }
}

@media (max-width: 767px) {
  .value-blocks-slider-component .slider-card {
    min-height: 367px;
    min-width: 275px;
  }
  .value-blocks-slider-component .slider-card-tagline {
    font-size: 2.1vw;
  }
  .value-blocks-slider-component .slider-card-title {
    font-size: 2.8vw;
  }
  .value-blocks-slider-component .slider-card-btn {
    font-size: 2.1vw;
  }
}

@media (max-width: 575px) {
  .value-blocks-slider-component .value-blocks-slider .scroll-horizontal {
    padding: 50px 20px;
  }
  .value-blocks-slider-component .slider-card-content {
    padding: 5vw;
  }
  .value-blocks-slider-component .slider-card-tagline {
    font-size: 4vw;
  }
  .value-blocks-slider-component .slider-card-title {
    font-size: 5vw;
    margin-bottom: 15px;
  }
  .value-blocks-slider-component .slider-card-btn {
    font-size: 4vw;
  }
}

/* Toyota Styles */
.value-blocks-slider-component[data-brand="toyota"] .value-blocks-slider .scroll-nav-btn {
  border-color: #000000;
}

/* INFINITI STYLES */
#valueBlocksSliderComponent[data-brand="infiniti"] .slider-card-top {
  opacity: 0;
}

#valueBlocksSliderComponent[data-brand="infiniti"] .slider-card-btn {
  display: none;
}

#valueBlocksSliderComponent[data-brand="infiniti"] .slider-card:hover {
  cursor: pointer;
}
#valueBlocksSliderComponent[data-brand="infiniti"] .slider-card:hover, 
#valueBlocksSliderComponent[data-brand="infiniti"] .slider-card:focus {
  -webkit-filter: brightness(0.7);
  filter: brightness(0.7);
}

</style>